export namespace RestrictionTypeId {
  export const Operator = 1n; // Limite definido pelo operador
  export const Ministry = 2n; // Limite imposto pelo ministério
  export const User = 3n; // Limite definido pelo usuário
  export const UserGroup = 4n; // Limite definido pelo grupo de usuários
}

export type RestrictionTypeIdType =
  (typeof RestrictionTypeId)[keyof typeof RestrictionTypeId];
